import { classNames } from "primereact/utils";
import styles from "./WizardHeader.module.scss";
import { useAppContext } from "../../../../../AppContext";
import { generateMapsLink } from "../../../../../common/infrastructure/routes/routePaths";

interface IWizardHeaderProps {
  className?: string;
}

export const WizardHeader = ({ className }: IWizardHeaderProps) => {
  const { selectedStudio, setShowSidebar } = useAppContext();

  return (
    <div className={classNames(styles.header, className)}>
      <button
        className={styles.burgerMenu}
        onClick={() => setShowSidebar(true)}
        type="button"
        aria-label="Menu"
      >
        <span className={styles.burgerLine}></span>
        <span className={styles.burgerLine}></span>
        <span className={styles.burgerLine}></span>
      </button>

      <div className={styles.studioInfo}>
        <h1 className={styles.studioTitle}>
          {selectedStudio?.name}
        </h1>
        <p
          className={styles.studioSubtitle}
          onClick={() =>
            window.open(
              generateMapsLink(
                selectedStudio?.address,
                selectedStudio?.addressMapUrl,
              ),
              "_blank",
              "noopener,noreferrer",
            )
          }
          style={{ cursor: "pointer" }}
        >
          {selectedStudio?.address}
        </p>
      </div>
    </div>
  );
};
